var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1794,
    height: 1102,
    transform: "translate(-1403 -300)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1407,
    y: -301,
    width: 1794,
    height: 1103,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1283,
    y: -198,
    width: 1645,
    height: 929,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -372,
    y: -111,
    width: 450,
    height: 201,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1258.5,
    y: -71.5,
    width: 1299,
    height: 167,
    rx: 9.5,
    fill: "white",
    stroke: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 3,
    fill: "#9196A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9009 11.5002V15.5438C16.9009 16.2926 16.2946 16.8989 15.5459 16.8989H7.45851C6.70979 16.8989 6.10352 16.2926 6.10352 15.5438V7.45671C6.10352 6.70791 6.70979 6.10156 7.45851 6.10156H11.5016",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3282 10.9521L14.6927 6.59413C14.9041 6.38272 15.2354 6.10156 15.6669 6.10156H15.7879C16.457 6.10156 17.0008 6.64535 17.0008 7.31446V7.43542C17.0008 7.76671 16.8406 8.08492 16.5093 8.40858L12.1503 12.7731L9.72119 13.3811L10.3282 10.9521Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_104_257",
    transform: "scale(0.000557414 0.000906618)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1794,
    height: 1102,
    fill: "white",
    transform: "translate(-1403 -300)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditGray);
export default __webpack_public_path__ + "static/media/icon-edit-gray.4e7dcd58f8e0906b54033170586fab43.svg";
export { ForwardRef as ReactComponent };